<template>
  <div class="page">
    <div class="nav" v-if="!isWeChatFlag">
      <p>车家-资料上传助手</p>
    </div>
    <div class="header">
      <img src="../../assets/image/CustomersInfo/header_banner.png"/>
    </div>
    <div class="content">
      <div class="sys_input">
        <div class="input_item">
          <input type="tel" v-model="mobile" placeholder="请输入手机号码" maxlength="11"  @blur="blur"></input>
        </div>
        <div class="input_item">
          <input type="number" v-model="vCode" placeholder="验证码" maxlength="6"  @blur="blur" @input="VCodeMaxLength"></input>
          <button @click="getCode" v-html="vCodeStr"></button>
        </div>
      </div>
      <div class="login-tip">确认提交的信息与资料属实，并同意用于车家相关的业务办理</div>
      <button class="login-btn" @click="login">同意并登录</button>
    </div>
    <div class="footer">
      <img src="../../assets/image/CustomersInfo/footer_banner.jpg"/>
      <p>上海有车有家融资租赁有限公司</p>
    </div>
  </div>
</template>

<script>
  import common from "../../utils/common";
  import VueCookies from 'vue-cookies';
  import _ from 'lodash'
  let vm = {
    name: "Cus_Login",
    data() {
      return {
        isWeChatFlag: false,
        mobile: '',
        vCode: '',
        vCodeStr: '获取验证码'
      }
    },
    mounted() {
      this.$nextTick(()=>{
        window.scrollTo(0, 0)
        this.isWeChatFlag = common.isWeChat()
      })
    },
    methods: {
      VCodeMaxLength() {
        if (this.vCode != null && this.vCode.length > 6) {
          this.vCode = this.vCode.slice(0, 6)
        }
      },
      /* ios页面回落 */
      blur(e) {
        common.blurPageScroll()
      },
      // 获取验证码
      getCode(e) {
        common.getVCodeAdminNew(this, e)
      },
      /* 登录 */
      login: _.throttle(function(){
          const that = this
        if (common.isEmpty(common.trimAll(that.mobile))) {
          common.tipToast('请输入手机号码')
          return
        }
        if (common.trimAll(that.mobile).length != 11) {
          common.tipToast('手机号码格式不正确')
          return
        }

        if (common.isEmpty(common.trimAll(that.vCode))) {
          common.tipToast('请输入验证码')
          return
        }
        if (common.trimAll(that.vCode).length != 6 && common.trimAll(that.vCode).length != 4) {
          common.tipToast('验证码格式不正确')
          return
        }
        const grant_type = 'mobile';
        let data = {mobile: 'ICM@' + that.mobile, code: that.vCode, grant_type}
        that.$axios({
          method: 'post',
          url: '/auth/mobile/token/sms',
          params:  data,
          headers: {
            'Authorization': 'Basic aWNtOmNoZWppYWl0MjAyMTA0MTE=',
          },
        }).then(function (res) {
          // 以秒为单位，设置1天过去
          VueCookies.set("tokenflag", true, 7195)
          sessionStorage.setItem("access_token", res.data.access_token)
          sessionStorage.setItem("mobile", that.mobile)
          sessionStorage.setItem("name", common.isEmpty(res.data.user_info.name)?'':res.data.user_info.name)
          common.redirect(that, 'cus_collect')
        })
      }, 1000)
    }
  }

  export default vm
</script>

<style scoped lang="less">
  .page {
    margin: 0 auto;
    width: 7.5rem;
    p, input {
      margin: 0;
      padding: 0;
    }
    .nav {
      width: 100%;
      height: 0.88rem;
      p {
        font-size: 0.36rem;
        font-weight: 700;
        color: #000000;
        text-align: center;
        line-height: 0.88rem;
      }
    }

    .header {
      width: 100%;
      font-size: 0;
      img {
        width: 100%;
        height: 100%;
      }
    }

    .content {
      /*margin-top: 0.36rem;*/
      display: flex;
      flex-flow: column nowrap;
      align-items: center;
      .sys_title {
        width: 100%;
        font-size: 0.4rem;
        font-weight: 600;
        color: #333333;
        text-align: center;
        line-height: 0.56rem;
      }
      .sys_input {
        margin-top: 0.37rem;
        width: 6.12rem;
        .input_item {
          padding-top: 0.25rem;
          display: flex;
          flex-flow: row nowrap;
          align-items: flex-end;
          justify-content: space-between;
        }
        input {
          height: 0.56rem;
          font-size: 0.3rem;
          color: #000;
          /*color: #B7B7B7;*/
          line-height: 0.3rem;
          outline: none;
          border-width: 0;
          border-bottom: 0.02rem solid #D8D8D8;
          border-radius: 0;
        }
        .input_item:first-child > input {
          width: 100%;
        }
        .input_item:last-child > input {
          width: 4.03rem;
        }
        .input_item:last-child > button {
          width: 1.9rem;
          height: 0.73rem;
          border: 0.02rem solid #3289FF;
          border-radius: 0.08rem;
          background: #fff;
          font-size: 0.26rem;
          color: #3289FF;
          text-align: center;
          white-space: nowrap;
        }
      }

      .login-btn {
        /*margin-top: 0.94rem;*/
        width: 6.12rem;
        height: 0.9rem;
        background: #3289FF;
        border-radius: 0.08rem;
        border-width: 0;
        outline: none;
        font-size: 0.3rem;
        color: #FFFFFF;
        text-align: center;
      }

      .login-tip {
        margin-top: 0.56rem;
        margin-bottom: 0.3rem;
        max-width: 6.12rem;
        font-size: 0.22rem;
        line-height: 0.3rem;
        color: #B2B2B2;
        text-align: center;
        white-space: nowrap;
        /*letter-spacing: -0.015rem;*/
      }


    }

    .footer {
      margin: 0.97rem 0 0.5rem 0;
      font-size: 0;
      width: 100%;
      display: flex;
      flex-flow: column nowrap;
      align-items: center;
      img {
        width: 4.22rem;
        height: 2.44rem;
      }

      p {
        margin-top: 1.042rem;
        font-size: 0.22rem;
        color: #C3C3C3;
        letter-spacing: -0px;
        text-align: center;
        line-height: 0.32rem;
      }
    }

    input::-webkit-input-placeholder {
      /* WebKit, Blink, Edge */
      color: #B7B7B7;
    }

    input:-moz-placeholder {
      /* Mozilla Firefox 4 to 18 */
      color: #B7B7B7;
    }

    input::-moz-placeholder {
      /* Mozilla Firefox 19+ */
      color: #B7B7B7;
    }

    input:-ms-input-placeholder {
      /* Internet Explorer 10-11 */
      color: #B7B7B7;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/CustomersInfo/Cus_Login.vue